var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"layout-content"},[_c('route-view')],1),_c('layout-footer',{attrs:{"menus":_vm.tabbarItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }